import {NgModule} from '@angular/core';
import {CdBasicConfigPage} from "./page/overview/cd-basic-config/cd-basic-config.page";
import {CD_ENTITY_PROVIDER} from "./cd.entity-provider";
import {CoreModule} from "../../core/core.module";
import {CD_TEST_PROVIDERS} from "./test/cd-test-definition";

@NgModule({
    declarations: [
        CdBasicConfigPage,

    ],
    exports: [
        CdBasicConfigPage,
    ],
    imports: [
        CoreModule
    ],
    providers: [CD_ENTITY_PROVIDER, CD_TEST_PROVIDERS]

})
export class CdModule {
}
